/**
 * For Premium
 * In Progress - ACTIVE + WITH SOME BIDS
 */
var LOAD_STATUS;
(function (LOAD_STATUS) {
    LOAD_STATUS[LOAD_STATUS["ALL"] = -1] = "ALL";
    LOAD_STATUS[LOAD_STATUS["EXPIRED"] = 0] = "EXPIRED";
    LOAD_STATUS[LOAD_STATUS["COMPLETED"] = 1] = "COMPLETED";
    LOAD_STATUS[LOAD_STATUS["ACTIVE"] = 3] = "ACTIVE";
    LOAD_STATUS[LOAD_STATUS["IN_TRANSIT"] = 4] = "IN_TRANSIT";
    LOAD_STATUS[LOAD_STATUS["STAND_BY"] = 5] = "STAND_BY";
    LOAD_STATUS[LOAD_STATUS["CANCELLED"] = 6] = "CANCELLED";
    LOAD_STATUS[LOAD_STATUS["UNDER_REVIEW"] = 9999] = "UNDER_REVIEW";
})(LOAD_STATUS || (LOAD_STATUS = {}));
const ALL_LOAD_STATUS = [
    LOAD_STATUS.EXPIRED,
    LOAD_STATUS.COMPLETED,
    LOAD_STATUS.ACTIVE,
    LOAD_STATUS.IN_TRANSIT,
    LOAD_STATUS.STAND_BY,
    LOAD_STATUS.CANCELLED
];
var LOAD_STATUS_TEXT;
(function (LOAD_STATUS_TEXT) {
    LOAD_STATUS_TEXT["ALL"] = "All";
    LOAD_STATUS_TEXT["EXPIRED"] = "Expired";
    LOAD_STATUS_TEXT["COMPLETED"] = "Completed";
    LOAD_STATUS_TEXT["ACTIVE"] = "Active";
    LOAD_STATUS_TEXT["IN_TRANSIT"] = "In Transit";
    LOAD_STATUS_TEXT["STAND_BY"] = "Stand By";
    LOAD_STATUS_TEXT["CANCELLED"] = "Cancelled";
    LOAD_STATUS_TEXT["UNDER_REVIEW"] = "Under Review";
})(LOAD_STATUS_TEXT || (LOAD_STATUS_TEXT = {}));
const LOAD_STATUS_TEXT_MAP = {
    [LOAD_STATUS.ALL]: "All",
    [LOAD_STATUS.EXPIRED]: "Expired",
    [LOAD_STATUS.COMPLETED]: "Completed",
    [LOAD_STATUS.ACTIVE]: "Active",
    [LOAD_STATUS.IN_TRANSIT]: "In Transit",
    [LOAD_STATUS.STAND_BY]: "Supplier confirmed",
    [LOAD_STATUS.CANCELLED]: "Cancelled",
    [LOAD_STATUS.UNDER_REVIEW]: "Under Review"
};
const ACTION_BY_LOAD_STATUS = {
    UPDATE_LOADING_TIME: [LOAD_STATUS.ACTIVE, LOAD_STATUS.STAND_BY, LOAD_STATUS.IN_TRANSIT],
    CS_ATTACH_LORRY: [LOAD_STATUS.IN_TRANSIT],
    CS_LOAD_ASSIGN: [LOAD_STATUS.ACTIVE, LOAD_STATUS.STAND_BY]
};
const ClubbedLoadStatus = {
    ALL_LOADS: {
        label: "All Loads",
        value: ALL_LOAD_STATUS
    },
    ALL_NON_EXPIRED_LOADS: {
        label: "All Non-Expired Loads",
        value: ALL_LOAD_STATUS.filter((ldSt) => ldSt != LOAD_STATUS.EXPIRED)
    },
    ACTIVE_LOADS: {
        label: "Active + Supplier Confirmed",
        value: [LOAD_STATUS.ACTIVE, LOAD_STATUS.STAND_BY]
    },
    WENT_INTRANSIT: {
        label: "Went In-Transit",
        value: [LOAD_STATUS.IN_TRANSIT, LOAD_STATUS.COMPLETED, LOAD_STATUS.CANCELLED]
    },
    ACTIVE_WITH_BOOKING_CONFIRMED: {
        label: "Active + Booking Paid",
        value: [LOAD_STATUS.ACTIVE],
        flags: {
            booking_confirmed: true
        }
    },
    BOOKING_CONFIRMED: {
        label: "All + Booking Paid",
        value: ALL_LOAD_STATUS,
        flags: {
            booking_confirmed: true
        }
    },
    ACTIVE: {
        label: LOAD_STATUS_TEXT_MAP[LOAD_STATUS.ACTIVE],
        value: [LOAD_STATUS.ACTIVE]
    },
    STAND_BY: {
        label: LOAD_STATUS_TEXT_MAP[LOAD_STATUS.STAND_BY],
        value: [LOAD_STATUS.STAND_BY]
    },
    EXPIRED: {
        label: LOAD_STATUS_TEXT_MAP[LOAD_STATUS.EXPIRED],
        value: [LOAD_STATUS.EXPIRED]
    },
    IN_TRANSIT: {
        label: LOAD_STATUS_TEXT_MAP[LOAD_STATUS.IN_TRANSIT],
        value: [LOAD_STATUS.IN_TRANSIT]
    },
    COMPLETED: {
        label: LOAD_STATUS_TEXT_MAP[LOAD_STATUS.COMPLETED],
        value: [LOAD_STATUS.COMPLETED]
    },
    CANCELLED: {
        label: LOAD_STATUS_TEXT_MAP[LOAD_STATUS.CANCELLED],
        value: [LOAD_STATUS.CANCELLED]
    }
};

export { ACTION_BY_LOAD_STATUS, ALL_LOAD_STATUS, ClubbedLoadStatus, LOAD_STATUS, LOAD_STATUS_TEXT, LOAD_STATUS_TEXT_MAP };
//# sourceMappingURL=loadStatus.js.map
